import { render, staticRenderFns } from "./RomaCardPoll.vue?vue&type=template&id=340d9951&"
import script from "./RomaCardPoll.vue?vue&type=script&lang=js&"
export * from "./RomaCardPoll.vue?vue&type=script&lang=js&"
import style0 from "./RomaCardPoll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
